<div class="mt-1 clear-button">
    <div class="align" *ngIf="!hasChannelSelected">
        <button mat-button color="primary" (click)="selectAll()" i18n="@@select-all-channel-selection">Select All</button>
    </div>
    <div class="align" *ngIf="hasChannelSelected">
        <button mat-button color="primary" (click)="clear()" i18n="@@clear-all-channel-selection">Clear All</button>
    </div>
</div>
<mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <li class="mat-tree-node">
            <button mat-icon-button disabled>
                <i class="ms-Icon" aria-hidden="true"></i>
            </button>
            <mat-checkbox class="tree-checkbox" (change)="todoLeafItemSelectionToggle(node)" [checked]="checklistSelection.isSelected(node)" [disabled]="node.IsDeprecated || !node.IsAvailableForTagging ? true : null" *ngIf="!node.IsRoot">{{node.Name}}</mat-checkbox>
            <span *ngIf="node.IsRoot">{{node.Name}}</span>
        </li>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
        <li class="d-block">
            <div class="mat-tree-node">
                <button mat-icon-button matTreeNodeToggle>
                    <i class="ms-Icon ms-Icon--{{nestedTreeControl.isExpanded(node) ? 'ChevronDownSmall' : 'ChevronRightSmall'}}"
                       aria-hidden="true"></i>
                </button>
                <mat-checkbox class="tree-checkbox" (change)="todoItemSelectionToggle(node)" [checked]="checklistSelection.isSelected(node)" [disabled]="node.IsDeprecated || !node.IsAvailableForTagging ? true : null" *ngIf="!node.IsRoot">{{node.Name}}</mat-checkbox>
                <span *ngIf="node.IsRoot">{{node.Name}}</span>
            </div>
            <ul [class.d-none]="!nestedTreeControl.isExpanded(node)" class="m-1 p-0 pl-1">
                <ng-container matTreeNodeOutlet></ng-container>
            </ul>
        </li>
    </mat-nested-tree-node>
</mat-tree>
